import { Link } from "gatsby";
import React, { useRef, useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import Title from "../../atoms/title/title";
import { useStaticQuery, graphql } from "gatsby";
import "./otherEditions.scss";
import { getFormatDate } from "../../../shared/utils/dateUtilities";

const OtherEditions = (props) => {
  const carouselRef = useRef();
  const scrollStep = 310;
  const [actualLine, setActualLine] = useState(0);
  const compClass = "m-otherEditions";
  const data = useStaticQuery(graphql`
    query otherEditionsQuery {
      allContentfulSubcategoria(
        filter: { tipoContenido: { eq: "Edición" } }
        limit: 4
        sort: { fields: nroEdicion, order: DESC }
      ) {
        nodes {
          nombreSubcategoria
          slug
          tipoContenido
          createdAt
          nroEdicion
          referenciaInterna {
            referenciaCabecera {
              tituloPrincipal
              tituloSpan
              imagenHeader {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  `);
  
  const editions = data.allContentfulSubcategoria.nodes
    .map((item) => ({
      slug: "/ediciones/" + item.slug,
      titulo: item.referenciaInterna?.referenciaCabecera?.tituloPrincipal,
      subTitulo: item.referenciaInterna?.referenciaCabecera?.tituloSpan,
      imagen:
        item.referenciaInterna?.referenciaCabecera?.imagenHeader?.file.url,
      fecha: getFormatDate(item.createdAt),
      edicion: item.nroEdicion,
    }))
    .sort((art1, art2) =>
      art1.edicion < art2.edicion ? 1 : art1.edicion > art2.edicion ? -1 : 0
    );

  const scrollCarousel = (direction) => {
    const carousel = carouselRef.current;
    let valueToScroll = 0;
    let newActiveLine = actualLine;
    if (direction === "left") {
      newActiveLine = newActiveLine === 0 ? 0 : newActiveLine - 1;
      valueToScroll =
        carousel.scrollLeft - scrollStep < 0
          ? 0
          : carousel.scrollLeft - scrollStep;
    } else {
      newActiveLine =
        newActiveLine === data.length - 1 ? data.length - 1 : newActiveLine + 1;
      valueToScroll =
        carousel.scrollLeft + scrollStep >= carousel.scrollWidth
          ? carousel.scrollWidth
          : carousel.scrollLeft + scrollStep;
    }
    carousel.scroll(valueToScroll, 0);
    setActualLine(newActiveLine);
  };
  return (
    <div className={compClass}>
      <div className={`${compClass}__head`}>
        <div className={`${compClass}__arrows`}>
          <BsChevronLeft onClick={() => scrollCarousel("left")} />
          <BsChevronRight onClick={() => scrollCarousel("right")} />
        </div>
        <Title titulo={props?.tituloGeneral} haveInnerHTML={true} />
      </div>
      <div className={`${compClass}__content`}>
        <div ref={carouselRef} className={`${compClass}__cards`}>
          {editions.map((item, index) => (
            <Link key={index} to={item.slug} className={`${compClass}__card`}>
              <img src={item.imagen} alt="" />
              <div className={`${compClass}__card-info`}>
                <p dangerouslySetInnerHTML={{ __html: item.titulo }}></p>
                <p>{item.subTitulo}</p>
              </div>
            </Link>
          ))}
        </div>
        <Link
          to={props?.redireccionBoton || ""}
          className={`${compClass}__button`}
        >
          Ver más
        </Link>
      </div>
    </div>
  );
};

export default OtherEditions;
